import React from 'react';
import stateClauses from '../helpers/state_clauses.json';

export default function Reinstatement(props) {
  const text = stateClauses[props.state];

  if (text && text.reinstatement) {
    return (
      <li>{text.reinstatement}</li>
    );
  }

  return null;
}
